import { AddIcon } from '@freighthub/silhouette-core'
import { computed } from 'mobx'
import { observer } from 'mobx-react'
import { Component, ReactElement } from 'react'
import { i18n, I18nInterface } from 'utils/localisation'

import { TNetworkEntityJSON, TNetworkEntityType } from '../NetworkEntity'
import { AutocompleteDataAttributes, NetworkAutocomplete } from './NetworkAutocomplete'
import { AutocompleteData, AutocompleteResult } from './NetworkAutocompleteOption'

export interface INetworkEntitySelectorProps extends I18nInterface {
  type: TNetworkEntityType
  inputId?: string
  placeholder?: string
  value: AutocompleteResult
  canModifyDirectory?: boolean
  isDisabled?: boolean
  onSearchEntities: (query: string) => Promise<AutocompleteResult[]>
  onSelect: (selection: object) => void
  onFooterSelect: () => void
  renderForm: (handleEntityCreated: (newEntity: TNetworkEntityJSON) => void) => ReactElement
  onSearchTextChange?: (searchText: string) => void
  dataAttributes?: AutocompleteDataAttributes
}

export class LeanNetworkEntitySelector extends Component<INetworkEntitySelectorProps> {
  constructor(props) {
    super(props)
    this.handleSelected = this.handleSelected.bind(this)
    this.handleFormCompletion = this.handleFormCompletion.bind(this)
    this.handleClear = this.handleClear.bind(this)
  }

  @computed
  get footer(): AutocompleteData {
    return {
      _id: 'footer',
      onClick: this.props.onFooterSelect,
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      text: this.props.localisationStore.translate(`add-${this.props.type}`),
      icon: <AddIcon />,
    }
  }

  handleSelected(selection: AutocompleteResult): void {
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    this.props.onSelect(selection.data.entity)
  }

  handleClear(): void {
    // @ts-expect-error TS(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
    this.props.onSelect(null)
  }

  handleFormCompletion(networkEntity: TNetworkEntityJSON): void {
    this.props.onSelect(networkEntity)
  }

  render() {
    const {
      inputId,
      placeholder,
      isDisabled,
      canModifyDirectory,
      value,
      renderForm,
      onSearchEntities,
      onSearchTextChange,
      dataAttributes,
    } = this.props

    return (
      <div>
        <NetworkAutocomplete
          hasFooter={canModifyDirectory}
          key={inputId}
          inputId={inputId}
          placeholder={placeholder}
          defaultValue={value}
          getCompletions={onSearchEntities}
          onSearchTextChange={onSearchTextChange}
          handleSelection={this.handleSelected}
          handleClear={this.handleClear}
          // @ts-expect-error TS(2322) FIXME: Type 'false | AutocompleteData | undefined' is not... Remove this comment to see the full error message
          footerData={canModifyDirectory && this.footer}
          isDisabled={isDisabled}
          dataAttributes={dataAttributes}
        />

        {renderForm(this.handleFormCompletion)}
      </div>
    )
  }
}

export const NetworkEntitySelector = i18n(observer(LeanNetworkEntitySelector))
